export default {
	green: `#36854e`,
	blue: `#4e97c8`,
	pink: `#973676`,
	teal: `#2f8986`,
	gray: `#455a67`,
	red: `#dc4d39`,
};
